import { GroupedFraudChecks } from './getGroupedFraudChecks'

// The number of flags the fraud flags panel lists. A domain check yields a flag per failing domain
// (and an advanced one per flag), so this can differ from the number of failed check results.
export const getGroupedFailedChecksCount = (groupedFraudChecks?: GroupedFraudChecks | null): number => {
  if (!groupedFraudChecks) return 0

  const { agent, domains, documents } = groupedFraudChecks
  const failedDomainChecksCount = domains.reduce((sum, domain) => sum + domain.failedChecks.total, 0)

  return agent.failedChecks.length + failedDomainChecksCount + documents.failedChecks.length
}
